import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=345c4142&scoped=true&lang=pug"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=345c4142&prod&lang=scss"
import style1 from "./Item.vue?vue&type=style&index=1&id=345c4142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345c4142",
  null
  
)

export default component.exports